import React, { useState } from 'react'
import { useSearchParams, Link } from 'react-router-dom'
import { teamAPI } from '../services/(adminapi)/teamAPI'

const AcceptInvitation = () => {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    if (!password || password.length < 6) {
      setError('Password must be at least 6 characters')
      return
    }
    if (password !== confirmPassword) {
      setError('Passwords do not match')
      return
    }
    if (!token) {
      setError('Invalid invitation link')
      return
    }
    setLoading(true)
    try {
      await teamAPI.acceptInvitation(token, password)
      setSuccess(true)
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to accept invitation')
    } finally {
      setLoading(false)
    }
  }

  if (!token) {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <h1 style={styles.title}>Invalid link</h1>
          <p style={styles.text}>This invitation link is invalid or missing. Please use the link from your email.</p>
          <Link to="/signin" style={styles.link}>Go to Sign in</Link>
        </div>
      </div>
    )
  }

  if (success) {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <div style={styles.successIcon}>✓</div>
          <h1 style={styles.title}>Invitation accepted successfully</h1>
          <p style={styles.text}>You can now sign in with your email and the password you just set.</p>
          <Link to="/signin" style={styles.button}>Sign in</Link>
        </div>
      </div>
    )
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>Accept invitation</h1>
        <p style={styles.text}>Set a password to join the team.</p>
        <form onSubmit={handleSubmit}>
          {error && (
            <div style={styles.error}>{error}</div>
          )}
          <div style={styles.fieldGroup}>
            <label style={styles.label}>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="At least 6 characters"
              style={styles.input}
              autoComplete="new-password"
            />
          </div>
          <div style={styles.fieldGroup}>
            <label style={styles.label}>Confirm password</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Confirm password"
              style={styles.input}
              autoComplete="new-password"
            />
          </div>
          <button type="submit" disabled={loading} style={styles.button}>
            {loading ? 'Accepting...' : 'Accept invitation'}
          </button>
        </form>
        <p style={styles.footer}>
          <Link to="/signin" style={styles.link}>Back to Sign in</Link>
        </p>
      </div>
    </div>
  )
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f8fafc',
    padding: '20px',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  card: {
    width: '100%',
    maxWidth: '400px',
    backgroundColor: '#fff',
    padding: '32px',
    borderRadius: '8px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
  },
  title: {
    fontSize: '24px',
    fontWeight: '700',
    color: '#1e293b',
    textAlign: 'center',
    margin: '0 0 8px 0',
  },
  text: {
    fontSize: '14px',
    color: '#64748b',
    textAlign: 'center',
    marginBottom: '24px',
  },
  fieldGroup: {
    marginBottom: '16px',
  },
  label: {
    display: 'block',
    fontSize: '14px',
    fontWeight: '600',
    color: '#334155',
    marginBottom: '6px',
  },
  input: {
    width: '100%',
    padding: '10px 12px',
    fontSize: '16px',
    border: '1px solid #e2e8f0',
    borderRadius: '6px',
    boxSizing: 'border-box',
  },
  button: {
    display: 'block',
    width: '100%',
    padding: '12px',
    fontSize: '16px',
    fontWeight: '600',
    color: '#fff',
    backgroundColor: '#2563eb',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    textDecoration: 'none',
    textAlign: 'center',
    marginTop: '8px',
  },
  error: {
    color: '#dc2626',
    fontSize: '14px',
    marginBottom: '16px',
    padding: '10px',
    backgroundColor: '#fef2f2',
    borderRadius: '6px',
  },
  successIcon: {
    width: '48px',
    height: '48px',
    margin: '0 auto 16px',
    borderRadius: '50%',
    backgroundColor: '#22c55e',
    color: '#fff',
    fontSize: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  footer: {
    textAlign: 'center',
    marginTop: '20px',
    fontSize: '14px',
  },
  link: {
    color: '#2563eb',
    textDecoration: 'none',
  },
}

export default AcceptInvitation
